import { getPageSnapshot } from "./getPageSnapshot";

export type PageContext = {
  app: string;
  route: string;
  page_snapshot: string;
};

/** Identifies the current page without capturing any of its rendered content. */
export type PageIdentity = Omit<PageContext, "page_snapshot">;

export function buildPageIdentity(): PageIdentity {
  return {
    app: window.location.hostname,
    route: window.location.pathname,
  };
}

export function buildPageContext(): PageContext {
  return {
    ...buildPageIdentity(),
    page_snapshot: getPageSnapshot(),
  };
}
